import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React from 'react';

var Charging = function Charging(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.623 5.985H7.78a.2.2 0 0 1-.199-.2V.35A.345.345 0 0 0 7.231 0a.337.337 0 0 0-.286.155L.813 9.355a.399.399 0 0 0 .332.62h3.842c.11 0 .2.09.2.2v5.436c0 .215.174.348.35.348a.337.337 0 0 0 .286-.155l6.132-9.199a.399.399 0 0 0-.332-.62Zm-5.239 6.82V9.177a.399.399 0 0 0-.399-.399H2.636l3.748-5.623v3.628c0 .22.179.399.399.399h3.349l-3.748 5.623Z",
    fill: "#171A20",
    fillRule: "nonzero"
  }));
};
Charging.defaultProps = {
  "'aria-label'": "hidden",
  width: "12",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
var ProfileSettings = function ProfileSettings(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.527 8.468a4.234 4.234 0 1 0 0-8.468 4.234 4.234 0 0 0 0 8.468Zm0-7.057a2.826 2.826 0 0 1 2.823 2.823 2.826 2.826 0 0 1-2.823 2.823 2.826 2.826 0 0 1-2.823-2.823 2.826 2.826 0 0 1 2.823-2.823Zm7.5 13.754c-.619-3.112-3.702-5.286-7.5-5.286-3.797 0-6.881 2.174-7.5 5.286-.084.423.028.86.307 1.2.298.364.74.571 1.214.571h11.958c.474 0 .916-.207 1.214-.57.28-.34.391-.778.307-1.201Zm-1.52.36H1.547c-.058 0-.1-.029-.137-.085.397-1.998 2.481-4.15 6.116-4.15s5.72 2.152 6.102 4.18a.16.16 0 0 1-.123.055Z",
    fill: "#171A20",
    fillRule: "nonzero"
  }));
};
ProfileSettings.defaultProps = {
  "'aria-label'": "hidden",
  width: "16",
  height: "17",
  xmlns: "http://www.w3.org/2000/svg"
};
var Dashboard = function Dashboard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.89 8.576 9.004.692a.657.657 0 0 0-.929 0L1.544 7.225h-.011v.01L.193 8.577a.657.657 0 1 0 .928.93l.412-.412v7.393c0 .362.294.657.657.657h4.38a.657.657 0 0 0 .657-.657V11.45h2.628v5.037c0 .362.294.657.657.657h4.38a.657.657 0 0 0 .657-.657V9.094l.411.411a.654.654 0 0 0 .93 0 .657.657 0 0 0 0-.929Zm-2.655 7.254h-3.066v-5.037a.657.657 0 0 0-.657-.657H6.57a.657.657 0 0 0-.657.657v5.037H2.847V7.78L8.54 2.086l5.694 5.694v8.05Z",
    fill: "#171A20",
    fillRule: "nonzero"
  }));
};
Dashboard.defaultProps = {
  "'aria-label'": "hidden",
  width: "17",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
};
var OrderHistory = function OrderHistory(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.569 16.797h8.018c.511 0 .925-.413.925-.924V7.625l.518.518a.923.923 0 0 0 1.307 0l2.249-2.252a.925.925 0 0 0 0-1.307L14.474.471a.927.927 0 0 0-.77-.264.887.887 0 0 0-.116-.007h-1.143a.924.924 0 0 0-.776.422c-.364.562-1.185.848-2.09.848-.907 0-1.727-.286-2.091-.848A.925.925 0 0 0 6.712.2H5.569a.973.973 0 0 0-.117.007.933.933 0 0 0-.77.264L.57 4.584a.925.925 0 0 0 0 1.308l2.25 2.25a.926.926 0 0 0 1.307 0l.517-.516v8.247c0 .51.414.924.925.924Zm7.326-10.723v9.338H6.261V6.054c0-.366 0-.693-.34-.834a.924.924 0 0 0-1.007.2l-1.44 1.235-1.392-1.449L5.49 1.882a.924.924 0 0 0 .692-.23h.08c.763.842 1.985 1.406 3.316 1.406 1.331 0 2.554-.564 3.317-1.406h.08a.923.923 0 0 0 .691.23l3.414 3.324-1.398 1.449-1.441-1.234a.923.923 0 0 0-1.008-.2c-.338.14-.338.466-.338.83v.023Z",
    fill: "#171A20",
    fillRule: "evenodd"
  }));
};
OrderHistory.defaultProps = {
  "'aria-label'": "hidden",
  width: "19",
  height: "17",
  xmlns: "http://www.w3.org/2000/svg"
};
var PaymentMethod = function PaymentMethod(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.246 0H2.578A2.278 2.278 0 0 0 .3 2.278v8.201a2.278 2.278 0 0 0 2.278 2.278h13.668a2.278 2.278 0 0 0 2.278-2.278V2.278A2.278 2.278 0 0 0 16.246 0Zm.91 10.479a.912.912 0 0 1-.91.91H2.578a.912.912 0 0 1-.911-.91V4.556h15.49v5.923Zm-15.49-7.29v-.911c0-.502.41-.911.912-.911h13.668c.502 0 .91.409.91.91v.912H1.667Zm1.368 6.15c0-.377.306-.683.683-.683h3.189a.684.684 0 0 1 0 1.367h-3.19a.684.684 0 0 1-.682-.683Z",
    fill: "#171A20",
    fillRule: "nonzero"
  }));
};
PaymentMethod.defaultProps = {
  "'aria-label'": "hidden",
  width: "19",
  height: "15",
  xmlns: "http://www.w3.org/2000/svg"
};
var Referral = function Referral(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.36 21.472 10 14l-7.368-2.358c-.672-.215-.702-1.154-.045-1.412l16.817-6.603a.75.75 0 0 1 .973.97l-6.604 16.921c-.257.66-1.2.628-1.414-.046Zm-.779-7.446 1.568 4.965L18.356 5.65l-13.26 5.206 4.88 1.562L14.69 8.96c.23-.17.518.119.349.35z",
    fill: "#171A20"
  }));
};
Referral.defaultProps = {
  width: "24",
  height: "20",
  viewBox: "0 0 24 22",
  xmlns: "http://www.w3.org/2000/svg"
};
var SignOut = function SignOut(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "#171A20",
    strokeWidth: "1.613",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7 8.5h8M11.294 5.106 14.688 8.5l-3.394 3.394M9.5 15.7H2.643c-.631 0-1.143-.645-1.143-1.44V2.74c0-.795.512-1.44 1.143-1.44H9.5"
  })));
};
SignOut.defaultProps = {
  "'aria-label'": "hidden",
  width: "16",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
};
var DEPLOYED_ENVIRONMENT = {
  LOCAL_DEV: 'localDev',
  DEV: 'Dev',
  QA: 'Qa',
  STAGE_US: 'Stage',
  STAGE2_US: 'Stage2',
  PROD_US: 'prodUS',
  STAGE_CN: 'Stage_CN',
  PROD_CN: 'prodCN',
  TEST: 'test'
};
var ORIGINS = {
  TESLA: 'TESLA',
  SHOP: 'SHOP',
  AUTH: 'AUTH'
};
var PAGES = {
  HOME: {
    ROUTE: '',
    NAME: 'myProducts',
    BASE_ROUTE: '/teslaaccount',
    ORIGIN: ORIGINS.TESLA,
    ICON: Dashboard
  },
  PROFILE_SETTINGS: {
    ROUTE: '',
    NAME: 'accountSettings',
    BASE_ROUTE: '/teslaaccount/profile-settings',
    ORIGIN: ORIGINS.TESLA,
    ICON: ProfileSettings
  },
  PAYMENT_METHOD: {
    ROUTE: '/payment-method',
    NAME: 'paymentMethod',
    BASE_ROUTE: '/teslaaccount/profile-settings',
    ORIGIN: ORIGINS.TESLA,
    ICON: PaymentMethod
  },
  CHARGING_HISTORY: {
    ROUTE: '',
    NAME: 'charging',
    BASE_ROUTE: '/teslaaccount/charging',
    ORIGIN: ORIGINS.TESLA,
    ICON: Charging
  },
  REFER_AND_EARN: {
    ROUTE: '/lootbox',
    NAME: 'referAndEarn',
    BASE_ROUTE: '/teslaaccount',
    ORIGIN: ORIGINS.TESLA,
    ICON: Referral
  },
  ORDER_HISTORY: {
    ROUTE: '/order-history',
    NAME: 'orderHistory',
    BASE_ROUTE: '/teslaaccount',
    ORIGIN: ORIGINS.TESLA,
    ICON: OrderHistory
  },
  SIGN_OUT: {
    ROUTE: '',
    NAME: 'signOut',
    BASE_ROUTE: "/teslaaccount/owner-xp/auth/logout?redirect=true",
    ORIGIN: ORIGINS.TESLA,
    ICON: SignOut
  }
};
var NAVIGATION_PAGE_STATE = 'NAVIGATION_PAGE_STATE';
_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DEPLOYED_ENVIRONMENT.LOCAL_DEV, 'ownership-stg'), DEPLOYED_ENVIRONMENT.DEV, 'ownership-stg'), DEPLOYED_ENVIRONMENT.QA, 'ownership-stg'), DEPLOYED_ENVIRONMENT.STAGE_US, 'ownership-stg'), DEPLOYED_ENVIRONMENT.STAGE2_US, 'ownership-stg'), DEPLOYED_ENVIRONMENT.STAGE_CN, 'ownership-cn-stg'), DEPLOYED_ENVIRONMENT.PROD_US, 'ownership'), DEPLOYED_ENVIRONMENT.PROD_CN, 'ownership-cn'), DEPLOYED_ENVIRONMENT.TEST, 'ownership-stg');
var originUrlMap = _defineProperty(_defineProperty(_defineProperty({}, ORIGINS.TESLA, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DEPLOYED_ENVIRONMENT.LOCAL_DEV, 'http://localhost:3002'), DEPLOYED_ENVIRONMENT.DEV, 'https://proxysvc-referral-dev.teslamotors.com'), DEPLOYED_ENVIRONMENT.QA, 'https://proxysvc-referral-qa.teslamotors.com'), DEPLOYED_ENVIRONMENT.STAGE_US, 'https://stage.tesla.com'), DEPLOYED_ENVIRONMENT.STAGE2_US, 'https://stage2.teslamotors.com'), DEPLOYED_ENVIRONMENT.STAGE_CN, 'https://stage.tesla.cn'), DEPLOYED_ENVIRONMENT.PROD_US, 'https://www.tesla.com'), DEPLOYED_ENVIRONMENT.PROD_CN, 'https://www.tesla.cn'), DEPLOYED_ENVIRONMENT.TEST, 'http://localhost:3002')), ORIGINS.SHOP, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DEPLOYED_ENVIRONMENT.LOCAL_DEV, 'https://tesla-ui-commerce-staging.stg.ep.tesla.services'), DEPLOYED_ENVIRONMENT.DEV, 'https://tesla-ui-commerce-staging.stg.ep.tesla.services'), DEPLOYED_ENVIRONMENT.QA, 'https://tesla-ui-commerce-staging.stg.ep.tesla.services'), DEPLOYED_ENVIRONMENT.STAGE_US, 'https://tesla-ui-commerce-staging.stg.ep.tesla.services'), DEPLOYED_ENVIRONMENT.STAGE2_US, 'https://tesla-ui-commerce-staging.stg.ep.tesla.services'), DEPLOYED_ENVIRONMENT.STAGE_CN, 'https://ui-stg.shop.tesla.cn'), DEPLOYED_ENVIRONMENT.PROD_US, 'https://shop.tesla.com'), DEPLOYED_ENVIRONMENT.PROD_CN, 'https://shop.tesla.cn'), DEPLOYED_ENVIRONMENT.TEST, 'https://tesla-ui-commerce-staging.stg.ep.tesla.services')), ORIGINS.AUTH, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DEPLOYED_ENVIRONMENT.LOCAL_DEV, 'https://auth-stage.teslamotors.com'), DEPLOYED_ENVIRONMENT.DEV, 'https://auth-stage.teslamotors.com'), DEPLOYED_ENVIRONMENT.QA, 'https://auth-stage.teslamotors.com'), DEPLOYED_ENVIRONMENT.STAGE_US, 'https://auth-stage.teslamotors.com'), DEPLOYED_ENVIRONMENT.STAGE2_US, 'https://auth-stage2.teslamotors.com'), DEPLOYED_ENVIRONMENT.STAGE_CN, 'https://auth-stage.tesla.cn'), DEPLOYED_ENVIRONMENT.PROD_US, 'https://auth.tesla.com'), DEPLOYED_ENVIRONMENT.PROD_CN, 'https://auth.tesla.cn'));
var ACCOUNTS_URL_PROD = 'https://accounts.tesla.com';
var ACCOUNTS_URL_STAGE = 'https://accounts-stage.tesla.com';
var PERSONAL_INFO_URL = '/##LOCALE##/account-settings/personal-information';

export { ACCOUNTS_URL_PROD, ACCOUNTS_URL_STAGE, DEPLOYED_ENVIRONMENT, NAVIGATION_PAGE_STATE, ORIGINS, PAGES, PERSONAL_INFO_URL, originUrlMap };
